<template>
  <v-form ref="form" v-model="valid">
    <v-row>
      <v-col cols="12" md="8" class="py-0 pt-3">
        <v-text-field
          id="adresse-field"
          v-model="adresse"
          :label="t('LABEL_ADRESSE')"
          :rules="requiredField"
          :outlined="isOutlined"
          :dense="isDense"
          @blur="persistToStore"
        />
      </v-col>
      <v-col cols="12" md="4" class="py-0 pt-3">
        <v-text-field
          id="zipCode"
          v-model="codePostal"
          v-mask="zipCodeMask"
          :label="t('LABEL_CODE_POSTAL')"
          :rules="requiredField"
          :outlined="isOutlined"
          :dense="isDense"
          @blur="persistToStore"
        />
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <v-text-field
          id="city"
          v-model="ville"
          :label="t('LABEL_VILLE')"
          :rules="requiredField"
          :outlined="isOutlined"
          :dense="isDense"
          @blur="persistToStore"
        />
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <v-autocomplete
          id="province"
          v-model="province"
          :label="t('LABEL_PROVINCE')"
          :items="provinces"
          item-text="name"
          item-value="id"
          clearable
          clear-icon="mdi-close"
          :outlined="isOutlined"
          :dense="isDense"
          @change="persistToStore"
        />
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <v-autocomplete
          id="country"
          v-model="pays"
          :label="t('LABEL_PAYS')"
          :items="countries"
          item-text="name"
          item-value="id"
          :rules="requiredField"
          :outlined="isOutlined"
          :dense="isDense"
          @change="persistToStore"
        />
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <v-text-field
          id="phone"
          v-model="phone"
          v-mask="phoneMask"
          :label="t('LABEL_TELEPHONE')"
          :outlined="isOutlined"
          :dense="isDense"
          @blur="persistToStore"
        />
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <v-text-field
          id="mobile"
          v-model="mobile"
          v-mask="phoneMask"
          :label="t('LABEL_CELLULAIRE')"
          :outlined="isOutlined"
          :dense="isDense"
          @blur="persistToStore"
        />
      </v-col>
    </v-row>

    <FormActionBar :cancel-label="t('RETOUR')" :valid-label="t('VALIDER')" @cancel-click="goBack" @valid-click="validate" />
  </v-form>
</template>

<script>
import { mask } from "vue-the-mask"
import { mapActions, mapGetters } from "vuex"
import FormActionBar from "@/components/FormActionBar"
import masks from "@/config/masks.json"
import PosteCanada from "@/mixins/PosteCanada"

export default {
  mixins: [PosteCanada],
  components: {
    FormActionBar
  },
  directives: {
    mask
  },
  data() {
    return {
      valid: false,
      posteCanadaMainConfig: {
        adresseKey: ""
      },
      adresse: "",
      codePostal: "",
      ville: "",
      province: "",
      pays: "",
      phone: "",
      mobile: "",

      masksList: null
    }
  },

  computed: {
    ...mapGetters(["countries", "provinces", "defaultCountry", "defaultProvince", "t", "isOutlined", "isDense"]),
    requiredField() {
      return [(v) => !!v || this.t("CHAMP_REQUIS")]
    },
    phoneMask() {
      if (!this.countryMasks) {
        return "XXXXXXXXXXXX"
      }
      return this.countryMasks.phone
    },
    zipCodeMask() {
      if (!this.countryMasks) {
        return "XXXXXXXXXXXX"
      }
      return this.countryMasks.zipCode
    },
    countryData() {
      if (!this.pays) {
        return null
      }
      return this.countries.find((c) => c.id === this.pays)
    },
    countryMasks() {
      if (!this.countryData) {
        return undefined
      }
      return this.masksList[this.countryData.code]
    }
  },
  watch: {
    valid() {
      if (this.valid) {
        this.$emit("validateStep")
      } else {
        this.$emit("invalidateStep")
      }
    }
  },
  created() {
    this.province = this.defaultProvince ? this.defaultProvince.id : 0
    this.pays = this.defaultCountry ? this.defaultCountry.id : 0
    this.masksList = masks
  },
  methods: {
    ...mapActions(["setContactInfo"]),
    persistToStore() {
      let info = {
        address: this.adresse,
        zipCode: this.codePostal,
        city: this.ville,
        province: this.province,
        country: this.pays,
        phone: this.phone,
        mobile: this.mobile
      }
      this.setContactInfo(info)
    },
    afterPosteCanadaFill() {
      this.persistToStore()
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.persistToStore()
        this.$emit("validateStep")
        this.goNext()
      }
    },
    goBack() {
      this.$emit("to-step", 2)
    },
    goNext() {
      this.$emit("to-step", 4)
    }
  }
}
</script>

<style>
</style>